import { GQLError } from '../apis/graphql/graphqlAPI';
import { RoutePath } from '../constants';

export type Error = {
  // in case of error, in graphQL instances, errorLink maps error with handleGraphQLErrors fn ( see logic inside ) and throw after failed query in message field
  // it`s type is GQLError, but it should be parsed
  message: string;
};

const handleGql403 = (error: Error): void => {
  try {
    const parsedGqlMappedError: GQLError = JSON.parse(error?.message);

    if (Array.isArray(parsedGqlMappedError?.details)) {
      const error403 = parsedGqlMappedError?.details?.find((item) => item.status === '403');

      if (error403) {
        window.location.href = RoutePath.FORBIDDEN;
        return;
      }
    }

    throw new Error(parsedGqlMappedError.message);
  } catch (_) {
    throw new Error(error.message);
  }
};

export default handleGql403;
